import { z } from "zod";
import { projectsId, environmentsId, templateContentsId } from "../../db_gen";

const notificationLogFiltersSchema = z.object({
  projectId: projectsId.optional(),
  environmentId: environmentsId.optional(),
  recipientType: z.enum(["email", "sms", "push"]).optional(),
  status: z
    .enum(["pending", "sent", "failed", "schema_validation_failed", "adapter_error"])
    .optional(),
  startDate: z.string().datetime().optional(),
  endDate: z.string().datetime().optional(),
  limit: z.number().int().positive().default(50),
  offset: z.number().int().min(0).default(0),
});

export default {
  list: notificationLogFiltersSchema,
  getAggregations: z.object({
    projectId: projectsId.optional(),
    environmentId: environmentsId.optional(),
    templateContentId: templateContentsId.optional(),
    startDate: z.date().optional(),
    endDate: z.date().optional(),
    groupBy: z.enum(["date", "recipientType", "status", "templateContentId"]).default("date"),
  }),
};
